import { supabase } from '../lib/supabase'
import { sanitizeFlowGraph } from '../types/qualityFlowchart'
import type { QualityFlowchartGraph } from '../types/qualityFlowchart'
import type {
  AssistantChatMessage,
  AssistantChatResponse,
} from '../types/flowchartAssistant'
import { getMcpFlowchartChatUrl } from './mcpConfig'

async function getAccessToken(): Promise<string> {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession()

  if (error) {
    throw new Error(error.message || 'Falha ao obter sessão do usuário.')
  }
  if (!session?.access_token) {
    throw new Error('Sessão expirada. Faça login novamente.')
  }
  return session.access_token
}

/**
 * Envia histórico + grafo atual do canvas ao assistente MCP (POST {VITE_MCP_URL}/flowchart/chat).
 */
export async function sendFlowchartChatMessage(params: {
  messages: AssistantChatMessage[]
  graph: QualityFlowchartGraph
  signal?: AbortSignal
}): Promise<AssistantChatResponse> {
  const token = await getAccessToken()
  const flowchartChatUrl = getMcpFlowchartChatUrl()

  const response = await fetch(flowchartChatUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      messages: params.messages,
      graph: sanitizeFlowGraph(params.graph),
    }),
    signal: params.signal,
  })

  if (!response.ok) {
    let message = `Assistente HTTP ${response.status}`
    try {
      const body = (await response.json()) as { error?: string; message?: string }
      message = body.error || body.message || message
    } catch {
      /* ignore */
    }

    if (response.status === 503) {
      throw new Error(
        message ||
          'Assistente desabilitado no servidor MCP. Configure OPENAI_API_KEY.'
      )
    }
    if (response.status === 401 || response.status === 403) {
      throw new Error(message || 'Sem permissão para usar o assistente de fluxograma.')
    }
    throw new Error(message)
  }

  const data = (await response.json()) as Record<string, unknown>
  const mensagem =
    typeof data.mensagem === 'string' && data.mensagem.trim()
      ? data.mensagem.trim()
      : typeof data.reply === 'string' && data.reply.trim()
        ? data.reply.trim()
        : typeof data.message === 'string' && data.message.trim()
          ? data.message.trim()
          : 'Resposta recebida.'

  const graph =
    data.graph === null || data.graph === undefined
      ? null
      : data.graph

  return { mensagem, graph }
}
